export default __webpack_public_path__ + "static/media/andrea--mobile@2x.4e894101.jpg";